export default "__VITE_ASSET__CdRXpQro__"